import { Typography } from "@mui/material";
import React from "react";



const MainTitle: React.FC = (props: any) => {
    return (
        <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            sx={{ flexGrow: 1 }}
        >
            {process.env.REACT_APP_APP_NAME}
        </Typography>
    );
}

export default MainTitle